import React, { useEffect, useState } from "react";
import { Button, Divider, Menu } from "@mui/material";
import {
  CommonDeleteModal,
  MuiBox,
  MuiIconButton,
  MuiTypography,
} from "components/atoms";
import { useNavigate } from "react-router-dom";

//SVGs
import LogoutIcon from "assets/images/svg-icons/logout.svg";
import PlusIcon from "assets/images/svg-icons/plusIcon.svg";
import HelpIcon from "assets/images/svg-icons/help-circle-contained.svg";
import SettingsIcon from "assets/images/svg-icons/settings.svg";
import DownArrow from "assets/images/svg-icons/chevron-down.svg";
import { useDispatch, useSelector } from "react-redux";
import { openCenterModal } from "store/slices/CenterModal.slice";
import SmartImage from "components/atoms/SmartImage";
import { useTranslation } from "react-i18next";
import {
  GetAccountListAction,
  LogOutAction,
  RemoveAccountAction,
  SwitchAccountAction,
} from "store/middlewares/session/auth";
import HelpAndFeedbackModal from "../HelpAndFeedbackModal";
import LocalstorageService from "utils/localstorage-services";
import HeaderToolsMenu from "../HeaderMenus/HeaderToolsMenu";
import UserProfileSkeleton from "../SkeletonLoaders/UserProfileSkeleton";
import {
  cancelUploadingAllFiles,
  clearFolderUpload,
  clearUploadFiles,
} from "store/slices/general";
import {
  abortAllUploads,
  abortFolderUpload,
  setLogoutInProgress,
} from "utils/uploadController";
import { urls } from "config/urls";

//user profile in the header

const UserProfile = () => {
  const navigate = useNavigate();
  const { profile } = useSelector((state) => state.profile);
  const [profileAnchorEl, setprofileAnchorEl] = useState(null);
  const isprofileopen = Boolean(profileAnchorEl);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [signOutAllFlag, setSignOutAllFlag] = useState(false);
  const currentUser =
    JSON.parse(localStorage.getItem("bigfoot-drive"))?.user || {};
  const existingInfo =
    JSON.parse(localStorage.getItem("bigfoot-otherInfo")) || {};
  const { accountListLoading, accountList } = useSelector(
    (state) => state.auth,
  );
  const { uploadNewFile, uploadFolderState } = useSelector(
    (state) => state.general,
  );

  // Returns true when a file or folder upload is actively in progress or when the upload modal is open.
  const isUploadInProgress = () => {
    const hasUploadingFiles = uploadNewFile?.list?.some(
      (file) => file.status === "uploading",
    );
    const isFolderUploading = uploadFolderState?.status === "uploading";
    const isUploadModalOpen = Boolean(
      uploadNewFile?.display || uploadFolderState?.display,
    );
    return hasUploadingFiles || isFolderUploading || isUploadModalOpen;
  };

  const path = currentUser?.drive_start_page === "drive" ? "mydrive" : "home";
  const redirectUrl = `${urls.DRIVE_URL}drive/${path}`;
  const accountLoginUrl = urls.ACCOUNT_URL;

  useEffect(() => {
    setSignOutAllFlag(accountList?.accountsOnDevice?.length > 0 ? true : false);
  }, [accountList]);

  useEffect(() => {
    dispatch(
      GetAccountListAction({
        deviceId: currentUser?.userSession?.device_id,
        appType: "drive",
      }),
    );
  }, [dispatch, existingInfo?.deviceId]);

  const openProfile = (event) => {
    setprofileAnchorEl(event.currentTarget);
  };

  const closesProfile = () => {
    setprofileAnchorEl(null);
  };

  return (
    <MuiBox
      sx={{
        display: "flex",
        alignItems: "center",
        gap: { xs: "8px", md: "16px" },
        width: "auto",
        maxWidth: "100%",
      }}
    >
      <MuiBox
        sx={{
          width: "auto",
          display: "flex",
          alignItems: "center",
          gap: { xs: "8px", md: "12px" },
        }}
      >
        <MuiBox sx={{ display: { xs: "none", md: "block" } }}>
          <MuiIconButton
            src={HelpIcon}
            size={"24px"}
            onClick={() =>
              dispatch(
                openCenterModal({
                  content: <HelpAndFeedbackModal />,
                  maxWidth: "840px",
                }),
              )
            }
          />
        </MuiBox>
        <HeaderToolsMenu />
        <MuiBox sx={{ display: { xs: "none", md: "block" } }}>
          <MuiIconButton
            src={SettingsIcon}
            size={"24px"}
            onClick={() => navigate("settings/editProfile")}
          />
        </MuiBox>
      </MuiBox>
      <Divider
        orientation="vertical"
        flexItem
        sx={{ display: { xs: "none", sm: "block" } }}
      />
      <MuiBox
        sx={{
          width: "auto",
          display: "flex",
          alignItems: "center",
          gap: { xs: "6px", md: "12px" },
          cursor: "pointer",
          maxWidth: { xs: "140px", sm: "200px", md: "none" },
        }}
        onClick={openProfile}
      >
        <MuiBox
          sx={{
            height: { xs: "28px", md: "32px" },
            width: { xs: "28px", md: "32px" },
            borderRadius: "50%",
            overflow: "hidden",
            flexShrink: 0,
          }}
        >
          <SmartImage
            src={profile?.image_url}
            alt={"profileImage"}
            className="img-cover"
            fallback={
              <MuiBox
                sx={{
                  bgcolor: profile?.avatar?.backgroundColor,
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <MuiTypography variant="14" color="text.white">
                  {profile?.avatar?.initials}
                </MuiTypography>
              </MuiBox>
            }
          />
        </MuiBox>
        <MuiBox
          sx={{
            width: "auto",
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
            minWidth: 0,
          }}
        >
          <MuiTypography
            fontWeight="500"
            variant="14"
            color="text.darkBlack"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "160px",
            }}
          >
            {profile?.first_name} {profile?.last_name}
          </MuiTypography>
          <MuiTypography
            fontWeight="500"
            variant="12"
            color="text.lightgray"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "160px",
            }}
          >
            {profile?.email}
          </MuiTypography>
        </MuiBox>
        <MuiIconButton src={DownArrow} size={"24px"} />
      </MuiBox>

      <Menu
        anchorEl={profileAnchorEl}
        open={isprofileopen}
        onClose={closesProfile}
        MenuListProps={{
          disablePadding: true,
        }}
        slotProps={{
          paper: {
            sx: {
              width: { xs: "calc(100vw - 24px)", sm: "auto" },
              minWidth: { xs: "unset", sm: "320px", md: "420px" },
              maxWidth: { xs: "calc(100vw - 24px)", sm: "480px", md: "520px" },
              borderRadius: { xs: "12px", md: "15px" },
              padding: 0,
              border: "4px solid",
              mt: "10px",
              borderColor: "background.gray400",
              boxShadow: "0px 0px 0px 1px #00000014",
              backgroundColor: "background.gray200",
              mx: { xs: "12px", sm: 0 }, // small side margin on mobile
            },
          },
        }}
      >
        {/* Top section – avatar + email + logout */}
        <MuiBox sx={{ p: { xs: "12px", md: "16px" } }}>
          <MuiBox
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <MuiBox
              sx={{
                height: { xs: "96px", sm: "120px", md: "150px" },
                width: { xs: "96px", sm: "120px", md: "150px" },
                flexShrink: 0,
                position: "relative",
              }}
            >
              <MuiBox
                sx={{
                  height: "100%",
                  width: "100%",
                  borderRadius: "50%",
                  overflow: "hidden",
                  flexShrink: 0,
                }}
              >
                <SmartImage
                  src={profile?.image_url}
                  enableFullscreen
                  hasCircle
                  alt={"profileImage"}
                  className="img-cover"
                  fallback={
                    <MuiBox
                      sx={{
                        bgcolor: profile?.avatar?.backgroundColor,
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <MuiTypography variant="32" color="text.white">
                        {profile?.avatar?.initials}
                      </MuiTypography>
                    </MuiBox>
                  }
                />
              </MuiBox>
            </MuiBox>
          </MuiBox>

          <MuiBox
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: { xs: "8px", md: "12px" },
              px: { xs: "4px", md: 0 },
              flexDirection: "column",
              textAlign: "center",
            }}
          >
            <MuiTypography
              variant="18"
              color="text.darkBlack"
              fontWeight={600}
              sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {profile?.first_name} {profile?.last_name}
            </MuiTypography>
            <MuiTypography
              variant={{ xs: "16", md: "18" }}
              color="text.darkBlack"
              fontWeight={600}
              sx={{
                wordBreak: "break-word",
                overflowWrap: "anywhere",
                textAlign: "center",
                maxWidth: "100%",
              }}
            >
              {profile?.email}
            </MuiTypography>
          </MuiBox>

          <MuiBox
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: { xs: "16px", md: "20px" },
              gap: "8px",
            }}
          >
            <Button
              variant="whiteContained"
              sx={{
                width: "fit-content",
                border: "2px solid",
                borderColor: "background.blue600",
              }}
              onClick={() => navigate("/drive/settings/editProfile")}
            >
              <MuiTypography
                variant="14"
                textAlign={"center"}
                fontWeight={"500"}
                color="primary.main"
              >
                {t("header.manageAccount")}
              </MuiTypography>
            </Button>

            <Button
              variant="whiteContained"
              sx={{
                width: "fit-content",
                border: "2px solid",
                borderColor: "#e12121b8",
                ":hover": { borderColor: "error.main" },
                px: { xs: "12px", md: "16px" },
              }}
              onClick={() => {
                const isUploadModalOpen = Boolean(
                  uploadNewFile?.display || uploadFolderState?.display,
                );
                // If all files/folders are uploaded (modal open, but no active upload),
                // close the upload modal and clear upload data before opening logout confirm modal.
                if (isUploadModalOpen && !isUploadInProgress()) {
                  dispatch(clearUploadFiles());
                  dispatch(clearFolderUpload());
                }
                closesProfile();
                dispatch(
                  openCenterModal({
                    content: (
                      <CommonDeleteModal
                        btnName={t("header.logout")}
                        title={t("modal.logout.areYouSureYouWantToLogout")}
                        description={t("modal.logout.removeAccountDesc")}
                        onClick={({ onSuccess, onError }) => {
                          // Check for active upload after user confirms in modal.
                          // If they cancel the browser dialog, do not call the API.
                          if (
                            isUploadInProgress() &&
                            !window.confirm(
                              "If you log out now, changes may not be saved. Do you want to continue?",
                            )
                          ) {
                            return;
                          }
                          // Cancel any active file/folder uploads before logging out.
                          setLogoutInProgress(true);
                          abortAllUploads();
                          dispatch(cancelUploadingAllFiles());
                          abortFolderUpload();
                          dispatch(clearFolderUpload());
                          dispatch(clearUploadFiles());
                          dispatch(
                            LogOutAction({
                              sessionId: currentUser?.userSession?.id,
                              deviceId: currentUser?.userSession?.device_id,
                              type: "single",
                              // appType: "drive",
                              onSuccess: () => {
                                onSuccess();
                              },
                              onError: () => onError(),
                            }),
                          );
                        }}
                      />
                    ),
                  }),
                );
              }}
            >
              <MuiTypography
                variant="14"
                component={"span"}
                textAlign={"center"}
                fontWeight={"500"}
                sx={{
                  color: "error.main",
                }}
              >
                {t("header.logout")}
              </MuiTypography>
            </Button>
          </MuiBox>
        </MuiBox>

        {/* Accounts list section */}
        <MuiBox
          sx={{
            p: { xs: "10px 12px", md: "12px 16px" },
            bgcolor: "background.white",
            display: "flex",
            flexDirection: "column",
            gap: { xs: "10px", md: "12px" },
          }}
        >
          <MuiBox>
            <MuiTypography
              variant={{ xs: "15", md: "16" }}
              color="text.gray900"
              fontWeight={500}
            >
              {t("header.switchAccounts")}
            </MuiTypography>
          </MuiBox>

          {accountListLoading ? (
            <UserProfileSkeleton />
          ) : (
            accountList?.accountsOnDevice?.map((item, index) => (
              <MuiBox
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (item.is_accessible) {
                    // const emails = currentUser?.accountsOnDevice?.map(
                    //   (item) => item?.user?.email,
                    // );
                    dispatch(
                      SwitchAccountAction({
                        email: item?.user?.email,
                        // emails: [...emails, currentUser.email],
                        deviceId: currentUser?.userSession?.device_id,
                        appType: "drive",
                      }),
                    );
                  }
                }}
              >
                <MuiBox
                  sx={{
                    display: "flex",
                    gap: { xs: "8px", md: "12px" },
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <MuiBox
                    sx={{
                      height: { xs: "32px", md: "36px" },
                      width: { xs: "32px", md: "36px" },
                      borderRadius: "50%",
                      overflow: "hidden",
                      flexShrink: 0,
                      opacity: item.is_accessible ? 1 : 0.5,
                      cursor: item.is_accessible ? "pointer" : "not-allowed",
                    }}
                  >
                    <SmartImage
                      src={
                        item?.user?.resized_image_urls?.small ??
                        item?.user?.image_url
                      }
                      alt={"profileImage"}
                      className="img-cover"
                      fallback={
                        <MuiBox
                          sx={{
                            bgcolor: item?.user?.avatar?.backgroundColor,
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <MuiTypography variant="12" color="text.white">
                            {item?.user?.avatar?.initials}
                          </MuiTypography>
                        </MuiBox>
                      }
                    />
                  </MuiBox>

                  <MuiBox
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flex: 1,
                      minWidth: 0, // critical for text wrapping
                      gap: "8px",
                    }}
                  >
                    <MuiBox
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        flex: 1,
                        minWidth: 0,
                        opacity: item.is_accessible ? 1 : 0.5,
                        cursor: item.is_accessible ? "pointer" : "not-allowed",
                      }}
                    >
                      <MuiTypography
                        variant="14"
                        color="text.darkBlack"
                        fontWeight={500}
                        sx={{
                          wordBreak: "break-word",
                          overflowWrap: "anywhere",
                          lineHeight: 1.3,
                        }}
                      >
                        {item?.user?.first_name} {item?.user?.last_name}
                        {!item?.is_accessible && (
                          <MuiTypography
                            component="span"
                            variant="14"
                            color="text.gray900"
                            sx={{ ml: 0.5 }}
                          >
                            ({t("header.signedOut")})
                          </MuiTypography>
                        )}
                      </MuiTypography>

                      <MuiTypography
                        variant="14"
                        color="text.gray900"
                        fontWeight={400}
                        sx={{
                          wordBreak: "break-word",
                          overflowWrap: "anywhere",
                          lineHeight: 1.3,
                        }}
                      >
                        {item.user?.email}
                      </MuiTypography>
                    </MuiBox>

                    <MuiTypography
                      variant="14"
                      component={"span"}
                      textAlign={"center"}
                      fontWeight={"500"}
                      sx={{
                        cursor: "pointer",
                        opacity: 1,
                        color: "error.main",
                        flexShrink: 0,
                        whiteSpace: "nowrap",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        dispatch(
                          openCenterModal({
                            content: (
                              <CommonDeleteModal
                                btnName={t("header.remove")}
                                title={t("modal.logout.removeAccount")}
                                description={t(
                                  "modal.logout.removeAccountDesc",
                                )}
                                onClick={() =>
                                  dispatch(
                                    RemoveAccountAction({
                                      email: item?.user?.email,
                                      deviceId: item?.device_id,
                                      // id: item?.id,
                                      appType: "drive",
                                    }),
                                  )
                                }
                              />
                            ),
                          }),
                        );
                      }}
                    >
                      {t("header.remove")}
                    </MuiTypography>
                  </MuiBox>
                </MuiBox>
                {index !== accountList?.accountsOnDevice?.length - 1 && (
                  <Divider />
                )}
              </MuiBox>
            ))
          )}

          {/* Add account */}
          <MuiBox
            sx={{
              display: "flex",
              gap: { xs: "8px", md: "12px" },
              alignItems: "center",
              mt: { xs: "8px", md: "12px" },
              cursor: "pointer",
            }}
          >
            <MuiBox
              sx={{
                height: { xs: "32px", md: "36px" },
                width: { xs: "32px", md: "36px" },
                borderRadius: "50%",
                overflow: "hidden",
                flexShrink: 0,
                border: "1px solid",
                borderColor: "background.gray600",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MuiBox sx={{ height: "20px", width: "20px" }}>
                <img src={PlusIcon} alt="PlusIcon" className="img-full" />
              </MuiBox>
            </MuiBox>
            <MuiBox
              sx={{ display: "flex", flexDirection: "column" }}
              onClick={() => {
                sessionStorage.removeItem("drive_first_login_done");
                LocalstorageService.startAddAccountFlow();
                window.location.href = `${accountLoginUrl}?redirect=${encodeURIComponent(
                  redirectUrl,
                )}&flow=addAccount`;
              }}
            >
              <MuiTypography
                variant={"14"}
                color="text.darkBlack"
                fontWeight={500}
              >
                {t("header.addAccount")}
              </MuiTypography>
            </MuiBox>
          </MuiBox>

          {/* Sign out of all accounts */}
          {signOutAllFlag && (
            <>
              <Divider />
              <MuiBox
                sx={{
                  display: "flex",
                  gap: { xs: "8px", md: "12px" },
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  const isUploadModalOpen = Boolean(
                    uploadNewFile?.display || uploadFolderState?.display,
                  );
                  // If all files/folders are uploaded (modal open, but no active upload),
                  // close the upload modal and clear upload data before opening logout confirm modal.
                  if (isUploadModalOpen && !isUploadInProgress()) {
                    dispatch(clearUploadFiles());
                    dispatch(clearFolderUpload());
                  }
                  closesProfile();
                  dispatch(
                    openCenterModal({
                      content: (
                        <CommonDeleteModal
                          btnName={t("modal.logout.logoutAll")}
                          title={t("modal.logout.logoutAllTitle")}
                          description={t("modal.logout.removeAccountsDesc")}
                          onClick={({ onSuccess, onError }) => {
                            // Check for active upload after user confirms in modal.
                            // If they cancel the browser dialog, do not call the API.
                            if (
                              isUploadInProgress() &&
                              !window.confirm(
                                "If you log out now, changes may not be saved. Do you want to continue?",
                              )
                            ) {
                              return;
                            }
                            // Cancel any active file/folder uploads before logging out.
                            setLogoutInProgress(true);
                            abortAllUploads();
                            dispatch(cancelUploadingAllFiles());
                            abortFolderUpload();
                            dispatch(clearFolderUpload());
                            dispatch(clearUploadFiles());
                            dispatch(
                              LogOutAction({
                                sessionId: currentUser?.userSession?.id,
                                deviceId: currentUser?.userSession?.device_id,
                                type: "all",
                                // appType: "drive",
                                onSuccess: () => {
                                  onSuccess();
                                },
                                onError: () => onError(),
                              }),
                            );
                          }}
                        />
                      ),
                    }),
                  );
                }}
              >
                <MuiBox
                  sx={{
                    height: { xs: "32px", md: "36px" },
                    width: { xs: "32px", md: "36px" },
                    borderRadius: "50%",
                    overflow: "hidden",
                    flexShrink: 0,
                    border: "1px solid",
                    borderColor: "background.gray600",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "error.red200",
                  }}
                >
                  <MuiBox sx={{ height: "20px", width: "20px" }}>
                    <img
                      src={LogoutIcon}
                      alt="LogoutIcon"
                      className="img-full"
                    />
                  </MuiBox>
                </MuiBox>
                <MuiBox sx={{ display: "flex", flexDirection: "column" }}>
                  <MuiTypography
                    variant={"14"}
                    color="text.darkBlack"
                    fontWeight={500}
                  >
                    {t("header.signOutOfAllAccounts")}
                  </MuiTypography>
                </MuiBox>
              </MuiBox>
            </>
          )}

          {/* Privacy / Terms */}
          <MuiBox
            sx={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              justifyContent: "center",
              py: { xs: "6px", md: "8px" },
              flexWrap: "wrap",
            }}
          >
            <MuiTypography
              variant={"14"}
              color="text.darkBlack"
              fontWeight={500}
              sx={{ cursor: "pointer", "&:hover": { color: "primary.main" } }}
              onClick={() =>
                window.open(`${accountLoginUrl}cms/privacy`, "_blank")
              }
            >
              {t("header.privacyPolicy")}
            </MuiTypography>
            <Divider orientation="vertical" sx={{ height: "16px" }} />
            <MuiTypography
              variant={"14"}
              color="text.darkBlack"
              fontWeight={500}
              sx={{ cursor: "pointer", "&:hover": { color: "primary.main" } }}
              onClick={() =>
                window.open(`${accountLoginUrl}cms/service`, "_blank")
              }
            >
              {t("header.termsOfService")}
            </MuiTypography>
          </MuiBox>
        </MuiBox>
      </Menu>
    </MuiBox>
  );
};

export default UserProfile;
